import React, { useState } from "react";
import { Compass } from "lucide-react";

export default function CoreQuestionCard({ question }) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="w-56 shrink-0 bg-indigo-50 border border-indigo-100 rounded-2xl p-4 shadow-sm self-start sticky top-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold text-indigo-800">核心问题</span>
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-6 h-6 rounded-full bg-indigo-200 flex items-center justify-center hover:bg-indigo-300 transition-colors"
        >
          <Compass size={13} className="text-indigo-700" />
        </button>
      </div>

      {expanded && (
        <p className="text-xs text-indigo-700 leading-relaxed">{question}</p>
      )}
    </div>
  );
}
